<template lang='pug'>
  #blog
    //- #search
    //-   .icon
    //-     search-icon
      
    nav( :class='{ open }' )
      .handle( @click='open = !open' )
        drag-icon.icon

      router-link( :to='{ name: "home" }' )
        img#logo( src='/logo.png' )
      
      divider.on-medium

      #nav-links

        nav-link.home.on-medium.vertical.centered( :to='{ name: "blog" }' )
          template( v-slot:icon )
            home-icon
          template( v-slot:text ) Blog Home

        nav-link.about.on-medium.vertical.centered( :to='{ name: "about" }' )
          template( v-slot:icon )
            about-icon
          template( v-slot:text ) About

        nav-link.contact.on-medium.vertical.centered( :to='{ name: "contact" }' )
          template( v-slot:icon )
            contact-icon
          template( v-slot:text ) Get in Touch
      
      divider.on-medium

      #slogan It's a New World
    main
      transition( name='fade' mode='out-in' )
        router-view
</template>

<script>
  import { db } from '@/main'
  import NavDrawer from '@/components/navs/drawer'
  import Divider from '@/components/containers/divider'
  import NavLink from '@/components/links/combo'
  import HomeIcon from 'vue-material-design-icons/PlaylistEdit'
  import ContactIcon from 'vue-material-design-icons/EmailVariant'
  import DragIcon from 'vue-material-design-icons/DragVerticalVariant'
  import AboutIcon from 'vue-material-design-icons/InformationOutline'
  import SearchIcon from 'vue-material-design-icons/Magnify'
  // import Algolia from '@/components/algolia/search'

  export default {
    name: 'blog.layout',

    components: {
      NavDrawer,
      Divider,
      NavLink,
      HomeIcon,
      ContactIcon,
      DragIcon,
      AboutIcon,
      SearchIcon
    },

    data() {
      return { 
        open: false
      }
    }
  }
</script>

<style lang="stylus">
  .fade-enter-active,
  .fade-leave-active {
    transition all 320ms
    transition-timing-function ease
  }

  .fade-enter,
  .fade-leave-active {
    opacity 0
  }

  nav
    box-shadow 0 0 16px 0 rgba( 0 0 0 .1 )
    color rgb( 216 216 216 )
    display flex
    flex-direction column
    height 100vh
    background linear-gradient(
      135deg,
      rgb( 72 72 72 ),
      rgb( 64 64 64 ),
      rgb( 96 96 96 )
    )
    .handle
      display none

  #logo
    width 100%
    padding 8% 24%
    display block
    box-sizing border-box
    // filter brightness( 84% )
    // background repeating-linear-gradient(
    //   45deg,
    //   rgba( 64 64 64 .6 ),
    //   rgba( 64 64 64 .6 ) 1px,
    //   rgba( 72 72 72 .6 ) 1px,
    //   rgba( 72 72 72 .6 ) 2px
    // )
    &:hover
      // filter brightness( 100% )
      // background rgba( 255 255 255 .1 )

  #nav-links
    display flex
    justify-content space-between
    font-size .75em
    background repeating-linear-gradient(
      135deg,
      rgba( 56 56 56 .75 ),
      rgba( 56 56 56 .75 ) 1px,
      rgba( 68 68 68 .75 ) 1px,
      rgba( 68 68 68 .75 ) 2px
    )
    .link
      padding 16px 16px 32px 16px
      padding 1em 1em 2em 1em
      flex-grow 1
    
  #slogan
    margin-top auto
    padding 32px
    text-align center
    font-family Yellowtail
    font-size 1.6em
      
  #search
    position fixed
    top 1.6vh
    right 1.6vw
    .icon
      font-size 2.8em
      cursor pointer

  #blog
    display grid
    grid-template-columns 360px 1fr
    height 100vh
    @media( max-width: 1080px )
      grid-template-columns 308px 1fr

    @media( max-width: 880px )
      grid-template-columns 88px 1fr
      nav
        font-size .9em
        padding 0
      #logo
        width 100%
        padding 1.5em 1.25em
      
      #slogan
        position absolute
        bottom 42px
        transform rotate(-90deg)
        left -52.5px

      #nav-links
        flex-direction column
        .link
          padding 1.75em 0

    @media( max-width: 480px )
      grid-template-columns 1fr
      nav
        position fixed
        z-index 2
        width 80%
        left -80%
        transition all 360ms
        &.open
          left 0
        .handle
          font-size 1.5em
          display block
          position absolute
          height 34px 
          width 13px
          border-radius 0 4px 4px 0
          right -13px
          top calc( 50vh - 72px/2)
          background linear-gradient(
            135deg,
            rgb( 72 72 72 ),
            rgb( 64 64 64 ),
            rgb( 96 96 96 )
          ), repeating-linear-gradient(
            45deg,
            rgba( 64 64 64 .6 ),
            rgba( 64 64 64 .6 ) 1px,
            rgba( 72 72 72 .6 ) 1px,
            rgba( 72 72 72 .6 ) 2px
          )
          .icon
            position relative
            top 4px
            right 4px
            font-size 1.1em
            color rgba( 240 240 240 .6 )

        #nav-links
          flex-direction row
        #logo
          padding 4vh 24vw
        #slogan
          position static
          bottom 0
          transform rotate( 0deg )
          left 0
  
  main
    height 100%
    overflow-y auto
</style>
